define('app/nav/NavBar',['require','hbs!./NavBar.hbs','glu/itemView','app/app','./PasswordChange','./TenantDetails','glu/dialog'],function(require) {
	'use strict';

	var tmpl = require('hbs!./NavBar.hbs'),
		ItemView = require('glu/itemView'),
		App = require('app/app'),
		PasswordChange = require('./PasswordChange'),
		TenantDetails = require('./TenantDetails'),
		Dialog = require('glu/dialog');


	return ItemView.extend({
		template: tmpl,

		events: {
			//'click .menu-aggregate': 'setAsAggregate',
			'click [data="change-password"]': 'changePassword',
			'click [data="tenant-details"]': 'tenantDetails'
		},

		username: function() {
			return App.user.getUsername();
		},

		serializeData: function() {
			return this;
		},

		changePassword: function(e) {
			e.preventDefault();
			Dialog.open(new PasswordChange());
		},
		tenantDetails: function(e) {
			e.preventDefault();
			Dialog.open(new TenantDetails());
		}
	});
});

